import type { GetServerSidePropsContext } from 'next';
import css from './index.module.scss';
import PageLayout from '@/components/PageLayout';
import { useGlobal } from '@/utils/useGlobal';
import PageCon from '@/components/Impressum';
import SEOlinksA from '@/components/SEOlinksA';
import { redirectTo404 } from '@/utils';

export default function Page({ SEO }: any) {
    const { useRouter, useLang, isMobile } = useGlobal();
    const { t } = useLang('impressum');
    const router = useRouter();
    const { locale = 'de' } = router;

    return (
        <>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA list={['de']} locale={locale} pathname={'impressum'} />
            <PageLayout className={`${css.productcontent}  product_common product_common_real`} theme={isMobile ? '' : 'black'}>
                <PageCon />
            </PageLayout>
        </>
    );
}

export async function getServerSideProps({ locale }: GetServerSidePropsContext) {
    const whiteLocaleList = ['de'];
    // 非白名单404
    if (!whiteLocaleList.includes(locale as string)) {
        return redirectTo404();
    }
    return {
        props: {},
    };
}
